/* eslint-disable no-underscore-dangle */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import Router from 'next/router';

import { acceptCounterOffer, rejecetCounterOffer } from 'models/marketplace';
import { StatusContext } from 'contexts/statusContext';
import { Button } from 'components/common';
import maskAmount from 'utils/maskAmount';

const CounterOfferBar = ({
  t, data, setData, setCounterOfferModalVisible,
}) => {
  const { setErrorState } = useContext(StatusContext);

  const [onResponse, setOnResponse] = useState(false);

  const rejectCounterOfferWithApi = async () => {
    try {
      setOnResponse(true);
      await rejecetCounterOffer(data._id);
      setCounterOfferModalVisible(false);
      setData({});
    } catch (error) {
      setErrorState({
        title: t('error'),
        text: error.message,
        buttonText: t('close'),
        type: 'error',
        onClickButton: () => setErrorState({}),
      });
    } finally {
      setOnResponse(false);
    }
  };

  const acceptCounterOfferWithApi = async () => {
    try {
      setOnResponse(true);
      await acceptCounterOffer(data._id);
      setCounterOfferModalVisible(false);
      setData({});
      Router.push('/profile/purchases');
    } catch (error) {
      setErrorState({
        title: t('error'),
        text: error.message,
        buttonText: t('close'),
        type: 'error',
        onClickButton: () => setErrorState({}),
      });
    } finally {
      setOnResponse(false);
    }
  };

  return (
    <div className="row">
      <div className="col-15 col-md-auto mb-4 mb-md-0">
        <div className="row h-100 align-items-stretch">
          <div className="col-auto col-md-auto align-self-center">
            <i className="fa-solid fa-bell text-yellow2 fs-22" />
          </div>
          <div className="col-13 col-md-auto align-self-center">
            <div className="fs-14 lh-1p4">{`${maskAmount(data.userLastOffer)} teklifiniz satıcı tarafından değerlendirildi ve satıcı size özel bir teklif gönderdi.`}</div>
            <div className="fs-14 fw-900">
              {`Satıcının sizin için olan yeni teklifi ${maskAmount(data.offer)}`}
            </div>
          </div>
        </div>
      </div>
      <div className="col-auto d-none d-md-block">
        <div className="separator separator--vertical separator--mh-40" />
      </div>
      <div className="col">
        <div className="row">
          <div className="col-15 col-lg mb-lg-0">
            <Button
              loading={onResponse}
              htmlType="submit"
              className="im-button im-button--primary im-button--fluid im-button--center im-button--size-40 fw-900"
              label="Teklifi Onayla"
              withoutFormItem
              onClick={() => acceptCounterOfferWithApi()}
            />
          </div>
          <div className="col-15 col-lg mb-lg-0">
            <div>
              <Button
                loading={onResponse}
                htmlType="submit"
                className="im-button im-button--outline-gray12 im-button--fluid im-button--center im-button--size-40 fw-900"
                label="Karşı Teklif"
                withoutFormItem
                onClick={() => setCounterOfferModalVisible(true)}
              />
            </div>
          </div>
          <div className="col-15 col-lg mt-3 mb-lg-0">
            <Button
              loading={onResponse}
              htmlType="submit"
              className="im-button im-button--outline-gray im-button--fluid im-button--center im-button--size-40 fw-900"
              label="Teklifi Reddet"
              withoutFormItem
              onClick={() => rejectCounterOfferWithApi()}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CounterOfferBar.propTypes = {
  t: PropTypes.func,
  setData: PropTypes.func,
  setCounterOfferModalVisible: PropTypes.func,
  data: PropTypes.object,
};

export default CounterOfferBar;
